module.exports = __webpack_public_path__ + "img/menu_item_bk.43ff4e72.png";